import lostAndFound from './components/lostAndFound'
import configuration from './components/configuration'
import houseKeeper from './components/houseKeeper'
import report from './components/report'
export default {
  views: {
    ...lostAndFound,
    ...configuration,
    ...houseKeeper,
    ...report
  }
}
